import { render } from "./inspectPhoto.vue?vue&type=template&id=2da39f88&scoped=true"
import script from "./inspectPhoto.vue?vue&type=script&lang=js"
export * from "./inspectPhoto.vue?vue&type=script&lang=js"

import "./inspectPhoto.vue?vue&type=style&index=0&id=2da39f88&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da39f88"]])

export default __exports__